import { Grid, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Form from "components/form/Form";
import { generateQueryOnSubmit, onClearFilter } from "components/generators/filtersGenerator";
import GeneratedInput from "components/generators/inputsGenerator";
import { FilterField } from "layout/TableConstructor/types";
import qs from "qs";
import { useMemo } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

interface FiltersProps {
  form: UseFormReturn<FieldValues>;
  filters: FilterField<object>[];
}

const Filters = ({ form, filters }: FiltersProps) => {
  const { reset, handleSubmit } = form;
  const [searchParams, setSearchParams] = useSearchParams();
  const params = useMemo(() => qs.parse(searchParams.toString()), [searchParams]);

  const onSubmit = (data: Record<string, unknown>) => {
    generateQueryOnSubmit(data, filters, setSearchParams, params);
  };

  const onClear = () => onClearFilter(filters, reset, setSearchParams, params);

  return (
    <Box
      sx={{
        mb: 2.5,
        backgroundColor: "#fff",
        borderRadius: 2,
        padding: 3,
        boxShadow: "0px 0px 7.3px 0px rgba(164, 184, 253, 0.24)",
      }}>
      <Form
        form={form}
        autoComplete='false'>
        <Stack spacing={2}>
          <Box>
            <Grid
              container
              spacing={3}
              alignItems='flex-end'>
              {filters.map((input) =>
                input.isHidden ? null : (
                  <Grid
                    item
                    xs={12}
                    md={3}
                    key={`filter-input-${input.name}`}>
                    <GeneratedInput
                      form={form}
                      input={input}
                    />
                  </Grid>
                )
              )}
            </Grid>
          </Box>
          <Stack
            spacing={2}
            direction='row'
            justifyContent='end'>
            <Button
              onClick={onClear}
              sx={{
                marginRight: 2,
              }}
              color='secondary'
              variant='contained'
              size='medium'>
              Сбросить
            </Button>
            <Button
              variant='contained'
              type='submit'
              onClick={handleSubmit(onSubmit)}
              size='medium'>
              Применить
            </Button>
          </Stack>
        </Stack>
      </Form>
    </Box>
  );
};

export default Filters;
